<!--
 * @Author: wh
 * @Date: 2020-08-13 21:45:29
 * @LastEditTime: 2021-01-22 15:44:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\productSales.vue
-->
<template>
    <div class="DataBulletin-productSales">
        <div class="block">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
            <div class="statistics">
                <div class="unit-con">
                    <span>销量单位：(万方)</span>
                    <span>收入单位：(万元)</span>
                    <span>价格单位：(元)</span>
                </div>
                <div class="row">
                    <div class="item volume">
                        <div class="item-text">
                            <span class="iconfont icontijikongjian"></span>
                            <span>本月销售方量</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_quantity_month }}
                        </div>
                    </div>
                    <div class="item sales">
                        <div class="item-text">
                            <span class="iconfont iconjine1"></span>
                            <span>本月销售收入</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_money_month }}
                        </div>
                    </div>
                    <div class="item price">
                        <div class="item-text">
                            <span class="iconfont iconjine1"></span>
                            <span>本月价格</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_price_month }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="item volume">
                        <div class="item-text">
                            <span class="iconfont icontijikongjian"></span>
                            <span>年累计销量</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_quantity_year }}
                        </div>
                    </div>
                    <div class="item sales">
                        <div class="item-text">
                            <span class="iconfont iconjine1"></span>
                            <span>本年销售收入</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_money_year }}
                        </div>
                    </div>
                    <div class="item price">
                        <div class="item-text">
                            <span class="iconfont iconjine1"></span>
                            <span>本年累计价格</span>
                        </div>
                        <div class="rectangle">
                            {{ data.sale_price_year }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="pie-chart pie-chart block">
            <h4 class="">
                <span> 累计销量结构分析</span>
                <span class="unit">单位（万方）</span>
            </h4>
            <div id="pieChart" class="chart"></div>
        </div>
        <div class="split"></div>
        <div class="line-chart block">
            <h4>量价结构分析</h4>
            <div id="lineChart" class="chart"></div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_blue from '@/assets/images/home/bg_blue.png';
export default {
    components: {},
    props: {},
    data() {
        return {
            showCalendarPop: false,
            currentDate: new Date(),
            date: '',
            showOrgPop: false,
            columns: [
                {
                    text: '全部',
                    children: [],
                },
            ],
            // 图表数据
            data: {},
            // 组织机构
            orgData: [],
            orgName: '全部',
            dic_code: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {

        this.init();
    },
    methods: {
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.date = year + '-' + month;
            this.getOrg();
            this.getSaleday();
        },
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                const res = yyq.map(item => {
                    item.text = item.dic_name;
                    if (item.children) {
                        item.children = item.children.map(v => {
                            v.text = v.dic_name;
                            return v;
                        });
                    } else {
                        item.children = [];
                    }
                    return item;
                });
                this.orgData = res;
                this.columns[0].children = this.orgData;
            }
        },
        async getSaleday() {
            const res = await this.getSaledayApi();
            if (res) {
                this.data = res;
                this.initLineChart();
                this.initPieChart();
            }
        },

        // 获取数据    
        getSaledayApi() {
            const data = {
                date: this.date,
                dic_code: this.dic_code,
            };
            const path = '/interfaceApi/report/data_express/production_trad';
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.getSaleday();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        confirmOrg(value) {
            this.showOrgPop = false;

            this.orgName = '';
            if (value[0]) {
                this.orgName += value[0];
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName = value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.orgData.map(item => {
                    if (item.children) {
                        item.children.map(v => {
                            if (v.text === value[2]) {
                                this.dic_code = v.dic_code;
                            }
                        });
                    }
                });
            } else if (value[1] && value[1] !== '请选择') {
                this.orgData.map(item => {
                    if (item.text === value[1]) {
                        this.dic_code = item.dic_code;
                    }
                });
            } else {
                this.dic_code = '';
            }
            this.getSaleday();
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 量价结构分析
        initLineChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                legend: {
                    data: ['销量', '价格'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.data.tendency_month,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(万方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(元/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(85,167,254,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(62,121,197,1)', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: true,
                            position: 'top',
                            fontSize: '12',
                            color: 'rgba(62,121,197,1)',
                            padding: [0, 10, 4, 10],
                            backgroundColor: {
                                image: bg_blue,
                            },
                        },
                        barWidth: 30,
                        data: this.data.tendency_quantity,
                    },
                    {
                        name: '价格',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            fontSize: '12',
                            padding: 0,
                            color: '#FA8436',
                        },
                        yAxisIndex: 1,
                        data: this.data.tendency_price,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        initPieChart() {
            const myChart = this.$echarts.init(document.getElementById('pieChart'));
            const data = [];
            this.data.structure_level.map((item, index) => {
                const json = { name: item, value: this.data.structure_level_quantity[index] };
                data.push(json);
            });
            const data2 = [];
            this.data.xl_structure_mark.map((item, index) => {
                const json = { name: item, value: this.data.xl_structure_mark_quantity[index] };
                data2.push(json);
            });
            const legendData = this.data.xl_structure_mark;
            const option = {
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: '1%',
                    align: 'left',
                    top: 'middle',
                    height: 200,
                    show: false,
                    data: legendData,
                },
                tooltip: {
                    trigger: 'item',
                    // formatter: function (params, ticket, callback) {
                    //     const str = params.name.split(' ')[0] + '：' + params.value;
                    //     return str;
                    // },
                    formatter: '{b} {c}',
                },
                series: [
                    {
                        type: 'pie',
                        data: data,
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}:{c}',
                        },
                        radius: [0, '40%'],
                        center: ['50%', '55%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                        },
                        clockwise: true,
                        animation: false,
                        color: ['#0EA9EC', '#FFB207', '#13C564', '#13C564', '#944EC8'],
                    },
                    {
                        type: 'pie',
                        data: data2,
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b} {c} \n {d}%',
                            rich: {
                                d: {
                                    color: '#333',
                                },
                            },
                        },
                        labelLine: {
                            length: 8,
                            length2: 6,
                            show: true,
                        },
                        radius: ['45%', '60%'],
                        center: ['50%', '55%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                            color: params => {
                                return this.data.xl_structure_mark_color[params.dataIndex];
                            },
                        },
                        animation: false,
                        // color: this.data.xl_structure_mark_color,
                    },
                ],
                backgroundColor: '#FFFFFF',
            };
            myChart.setOption(option, true);
        },
    },
};
</script>
<style lang="stylus">
.DataBulletin-productSales
    height 100%
    overflow-y auto
    .block
        background #fff
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
        .statistics
            .unit-con
                font-size 12rpx
                color #979EA7
                margin-top 10rpx
                display flex
                span
                    flex 1
            .row
                display flex
                justify-content space-between
                margin-top 10rpx
                .item
                    flex 1
                    flex-shrink 0
                    width 33.333%
                    font-size 12rpx
                    color #979EA7
                    .iconfont
                        font-size 12rpx
                        color #979EA7
                        margin-right 3rpx
                    .rectangle
                        padding 0 2rpx
                        margin-top 5rpx
                        height 40rpx
                        background rgba(85,136,241,0.06)
                        border-radius 4rpx
                        text-align center
                        line-height 40rpx
                        font-size 18rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &.sales
                        margin 0 5rpx
                        .rectangle
                            background rgba(250,132,54,0.06)
                            color #FA8436
                    &.volume
                        .rectangle
                            background rgba(85,136,241,0.06)
                            color #5588F1
                    &.price
                        .rectangle
                            background rgba(33,189,204,0.06)
                            color #21BDCC
    .split
        height 15rpx
        background #F0F0F0
    .line-chart
        height 256rpx
        h4
            margin-bottom .1rem
    .pie-chart
        height 256rpx
        h4
            margin-bottom .2rem
        .chart
            width 100%
            height calc(100% - 30rpx)
    .line-chart
        height 300rpx
        h4
            margin-bottom 20rpx
        .chart
            width 100%
            height calc(100% - 40rpx)
</style>